import { FC } from "react";

import { TransferCalculator } from "../../components/widgets";
import { Currency } from "../../types/InvoiceTypes";
import { useGetPublicPaymentRequestPriceDataQuery } from "../../store/services/paymentRequestLinks";

export const PublicCalculatorPage: FC = () => {
  const { data } = useGetPublicPaymentRequestPriceDataQuery();

  return (
    <div className="flex w-full h-full">
      <TransferCalculator
        allowedIncomingCurrencies={[Currency.EUR, Currency.GBP, Currency.USD]}
        allowedOutgoingCurrencies={[Currency.INR]}
        priceData={data}
      />
    </div>
  );
};
